module.exports = __webpack_public_path__ + "98df9ccc67832a7717c53d54b68039b2.png";